module.exports = __webpack_public_path__ + "img/logoUfma.38243ace.svg";